import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 667,
	height: 667,
	viewBox: "0 0 667 667",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M502.237 9.05233C516.667 3.076 532.13 0 547.747 0C563.363 0 578.827 3.076 593.257 9.05233C607.683 15.0287 620.793 23.7883 631.837 34.831C642.88 45.8737 651.64 58.9833 657.617 73.4117C663.59 87.8397 666.667 103.304 666.667 118.92C666.667 134.537 663.59 150.001 657.617 164.429C651.64 178.857 642.88 191.967 631.837 203.01L614.563 220.282L446.387 52.1027L463.657 34.831C474.7 23.7883 487.81 15.0287 502.237 9.05233Z" }), /* @__PURE__ */ _jsx("path", { d: "M399.247 99.2437L55.1533 443.337C51.0513 447.437 48.0909 452.54 46.5646 458.137L1.17527 624.564C-1.97206 636.104 1.30561 648.447 9.76394 656.904C18.2223 665.364 30.5643 668.64 42.1046 665.494L208.532 620.104C214.129 618.577 219.23 615.617 223.332 611.514L567.423 267.424L399.247 99.2437Z" })]
});
export default SvgEdit;
